import Repository from "@shared/services/api/abstracts/Repository";
import { PublicUserClaimSerializerType } from "@shared/modules/auth/serializer-types";

export default class PublicUserClaimRepository extends Repository<PublicUserClaimSerializerType> {
  public readonly repositoryName = "PublicUserClaimRepository";

  public readonly endpoint = "api/user/claim/";
}
